import {
  EMPTY,
  Observable,
  catchError,
  concat,
  distinctUntilChanged,
  exhaustMap,
  fromEvent,
  interval,
  map,
  of,
  startWith,
  switchMap,
} from 'rxjs';

/**
 * Lädt sofort und danach alle `intervalMs`, solange das Dokument sichtbar ist (NEX-1731). Im
 * Hintergrund ruht der Takt; beim Zurückkommen wird sofort geladen. Eine laufende Anfrage wird
 * nicht doppelt gestartet. Ein Fehler kommt als `null` an, damit der Takt weiterläuft.
 */
export function pollWhileVisible<T>(
  load: () => Observable<T>,
  intervalMs: number,
  doc: Document = document,
): Observable<T | null> {
  return fromEvent(doc, 'visibilitychange').pipe(
    startWith(null),
    map(() => doc.visibilityState === 'hidden'),
    distinctUntilChanged(),
    switchMap((hidden) => (hidden ? EMPTY : concat(of(0), interval(intervalMs)))),
    exhaustMap(() => load().pipe(catchError(() => of(null)))),
  );
}
